import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { usePermissions } from 'hooks/usePermissions'
import { useSelector } from 'react-redux'

export const SitexProLink = ({ address, onClick }: { address: string; onClick: Function }) => {
  const { hasPermission } = usePermissions()
  const canViewSitexPro = hasPermission('Global.SitexPro')

  const { SitexPro } = useSelector((state: any) => state.vendor)

  if (!address || !SitexPro || !canViewSitexPro) return null

  return (
    <div className="flex items-center justify-end gap-1 text-shade-blue hover:underline cursor-pointer">
      <span className="font-semibold" onClick={() => onClick()}>
        SitexPro
      </span>
      <ArrowDownTrayIcon className="w-3 h-3" />
    </div>
  )
}
